export { default, getStaticProps } from '../../src/pages/Tutorials'
